import React from "react";

// Catches an error thrown while rendering the portal. Without it React 17
// unmounts the whole tree and the user is left with a blank page and no way
// to tell what happened (the blank screen of step 5a was one such error).
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error, info) {
        console.error(error, info.componentStack);
    }

    render() {
        if (!this.state.failed) {
            return this.props.children;
        }
        return (
            <div role="alert" style={{ maxWidth: "480px", margin: "120px auto", padding: "0 16px", textAlign: "center", fontFamily: "sans-serif" }}>
                <p>Ocurrió un error inesperado al mostrar el portal.</p>
                <p>Recargue la página. Si el problema continúa, intente de nuevo más tarde.</p>
                <button type="button" onClick={() => window.location.reload()}>Recargar</button>
            </div>
        );
    }
}

export default ErrorBoundary;
